@if (isOpen$ | async){
<div
  class="fixed inset-0 flex justify-center items-center bg-black/50 backdrop-blur-sm z-[140] px-5"
>
  <div
    class="
        relative w-full bg-white dark:bg-gray-900 shadow-xl flex flex-col
        transition-colors duration-300 ease-in-out border border-gray-200 dark:border-gray-700
        rounded-2xl
        {{ modalSizeClasses }}
      "
  >
    <div class="flex justify-between items-center p-4 border-b shrink-0">
      <h2
        class="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate"
      >
        {{ config()?.title || "Confirmación" }}
      </h2>
      @if(config()?.closable !== false){
      <button
        (click)="close()"
        class="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-lg"
      >
        <svg
          class="w-6 h-6 text-gray-500 dark:text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      }
    </div>
    <div class="p-6 text-center text-gray-700 dark:text-gray-300">
      {{ config()?.message || "¿Estás seguro?" }}
    </div>
    <div class="flex justify-end gap-4 p-4 border-t">
      <button
        type="button"
        (click)="close()"
        class="btn-cancel-soft"
      >
        Cancelar
      </button>
       <app-button
        (click)="confirm()"
        label="Confirmar"
        [fullWidth]="false"
        [variant]="'primary'"
        [size]="'md'"
      ></app-button>
    </div>
  </div>
</div>
}
